import { AfterViewInit, Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthenticationService } from '@app/core';
import { AnimatedModalComponent } from '@app/shared/modals/animated-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ModalService } from '@app/shared/modal.service';

@Component({
  selector: 'app-chest-for-deposit-modal',
  template: `
    <div (click)="reject()" class="icon close-popup"><i class="fal fa-times"></i></div>

    <div class="label blue-label">gift received</div>
    <div class="_10px-spacer"></div>
    <h3>You received a new chest!</h3>
    <img src="/assets/images/v2/jackpot/open-chest/chest.svg" height="160" class="chest" />
    <p>Inside you’ll find up to 10 keys. One lucky key will open the jackpot chest!</p>
    <a [routerLink]="['/', { outlets: { modal: 'open-chest' } }]" (click)="close()">
      <app-form-button class="primary full-width">Open</app-form-button>
    </a>
  `,
  styles: [
    `
      :host {
        text-align: center;
        align-items: center;
        display: flex;
        flex-direction: column;
      }
      .log-in-or-text {
        margin-top: 10px;
        margin-bottom: 10px;
      }
      h3 {
        margin-bottom: 0;
      }
      .chest {
        margin-top: 20px;
        margin-bottom: 20px;
      }
    `,
  ],
})
export class ModalChestForDepositComponent extends AnimatedModalComponent implements AfterViewInit {
  form: FormGroup;
  loading = false;
  errors = null;
  person: any = '';
  _service: ModalService;

  constructor(
    private ref: NgbActiveModal,
    private formBuilder: FormBuilder,
    private auth: AuthenticationService,
    protected elRef: ElementRef,
    protected renderer: Renderer2,
    protected router: Router,
    protected activatedRoute: ActivatedRoute,
    protected http: HttpClient
  ) {
    super(elRef, renderer);
  }

  ngAfterViewInit() {}

  public close(): void {
    this.auth.guestWon = true;
    this.ref.close(0);
  }

  public reject(): void {
    this.auth.guestWon = true;
    this.ref.dismiss(1);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/chest-for-deposit-modal.component.ts